// extracted by mini-css-extract-plugin
export default {"count":"countdown_count__gHu5-"};